import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { LoggedUser } from './logged-user.model';
const PRODUCTION = environment.production;

@Injectable({ providedIn: 'root' })
export class AuthGuard2 implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | Observable<boolean> | Promise<boolean> {
    const loggedUser: LoggedUser = this.authService.getLoggedUser();
    const path = route.routeConfig.path;

    if (!loggedUser.accept_date) {
      this.router.navigate(['/terms']);
      return false;
    }

    return true;
  }

}
